import { useQuery } from '@tanstack/react-query';
import { fetchCompanyPeriodRequests } from '../../../services/queries/KpiCollectionQueries';
import { DataCollectionType } from '../../../schemas/CompanyPeriodRequest.schema';

export function useCompanyPeriodRequestData() {
  return useQuery({
    queryKey: ['companyPeriodRequestData', DataCollectionType.kpi],
    queryFn: () => fetchCompanyPeriodRequests(DataCollectionType.kpi),
  });
}
